export const estadoColor = (e) => {
  if (!e) return "muted";
  const m = { 
    "Recepción": "muted", 
    "Diagnóstico": "warning", 
    "Reparación": "warning", 
    "En reparación": "warning", // ✅ NUEVO
    "En depósito": "warning",   // ✅ NUEVO
    "Reparado": "success", 
    "Entregado": "success", 
    "Cerrado": "muted", 
    "Aprobado": "success", 
    "Pendiente": "warning", 
    "Rechazado": "danger", 
    "Éxito": "success", 
    "Alerta": "warning", 
    "Error": "danger", 
    "Activo": "success", 
    "Inactivo": "muted" 
  };
  return m[e] || "muted";
};